
/* injects from baggage-loader */

'use strict';

import AccountActivityComponent from './account.activity.component';

const AccountActivityPageModule = angular.module('account-activity-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('account.activity', {
        name: 'Activity',
        url: '/activity',
        component: 'accountActivity',
        protected: true,
        // Resolve promises into controller bindings, see component for bindings
        resolve: { 
          // events: function(Activity) {
          //   return Activity.fetchSome();
          // }
        }
      });
  })
  .component('accountActivity', new AccountActivityComponent());

export default AccountActivityPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/account/activity/account.activity.module.js